(function () {
  var STORAGE_KEY = 'gh_recently_viewed';

  function getViewed() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function recordCurrentProduct() {
    var root = document.querySelector('[data-recently-viewed-record]');
    if (!root) return;
    var handle = root.dataset.recentlyViewedRecord;
    if (!handle) return;
    var viewed = getViewed().filter(function (h) {
      return h !== handle;
    });
    viewed.unshift(handle);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed.slice(0, 12)));
  }

  function renderRecentlyViewed() {
    var section = document.querySelector('[data-recently-viewed-list]');
    if (!section) return;
    var currentHandle = section.dataset.currentHandle;
    var count = parseInt(section.dataset.count, 10) || 5;
    var handles = getViewed()
      .filter(function (h) {
        return h !== currentHandle;
      })
      .slice(0, count);

    if (!handles.length) {
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) {
        return;
      }
      section.closest('.recently-viewed').hidden = false;
      section.innerHTML = products
        .map(function (p) {
          var image = p.featured_image || (p.images && p.images[0]) || '';
          var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
          return (
            '<a href="' + p.url + '" class="recently-viewed__item">' +
            '<div class="recently-viewed__image-wrapper">' +
            (image ? '<img src="' + image + '&width=300" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</div>' +
            '<p class="recently-viewed__title">' + p.title + '</p>' +
            '</a>'
          );
        })
        .join('');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    recordCurrentProduct();
    renderRecentlyViewed();
  });
})();
